





















import { defineComponent } from '@vue/composition-api';
import ElOption            from 'element-ui/lib/option';

export default defineComponent({
  name: 'cOption',
  components: {
    ElOption,
  },
});
